/** API origin — empty string = same-origin (web on Worker). Set VITE_API_BASE for Capacitor bundled builds. */
export function apiBase(): string {
  const base = (import.meta.env.VITE_API_BASE as string | undefined)?.replace(/\/$/, '') ?? ''
  return base
}

export function apiUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`
  return `${apiBase()}${p}`
}

/** Media paths from the API are relative; Capacitor loads the shell from https://localhost. */
export function mediaUrl(path: string | null | undefined): string | null {
  if (!path) return null
  if (/^https?:\/\//i.test(path)) return path
  return apiUrl(path)
}

const PRODUCTION_ORIGIN = 'https://pairvelle.com'

/** Browser.open and external handoffs require an absolute URL. */
export function absoluteUrl(pathOrUrl: string): string {
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`
  const origin = apiBase() || (typeof window !== 'undefined' ? window.location.origin : '') || PRODUCTION_ORIGIN
  return `${origin.replace(/\/$/, '')}${path}`
}
